import script from "./BarcodeGeneration.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeGeneration.vue?vue&type=script&setup=true&lang=js"

import "./BarcodeGeneration.vue?vue&type=style&index=0&id=7836eb56&lang=css"

const __exports__ = script;

export default __exports__